export const SUBSIDISED_PRODUCT_TYPE_ID = '26a41eb6-a9d1-4d2f-88e5-1bb59bdb9ae1';

const SUBSIDISED_PRODUCT_TYPE_NAMES = ['CursoBonificado', 'Bonificada'];

export const isSubsidisedProductType = (productType?: { id?: string; name?: string } | null): boolean => {
    if (!productType) {
        return false;
    }

    if (productType.id === SUBSIDISED_PRODUCT_TYPE_ID) {
        return true;
    }

    return Boolean(productType.name && SUBSIDISED_PRODUCT_TYPE_NAMES.includes(productType.name));
};

export const isContractInBlockedEntryFlow = (
    currentProductStatusId: string | null | undefined,
    blockedEntryProductStatusIds: string[]
): boolean => {
    if (!currentProductStatusId || !blockedEntryProductStatusIds.length) {
        return false;
    }

    return blockedEntryProductStatusIds.includes(currentProductStatusId);
};
